"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function updateSessionsCompleted(aggregatedStat, sessionEvent) {
    return aggregatedStat.sessionsCompleted + 1;
}
exports.default = updateSessionsCompleted;
